function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _ = require('lodash');

var React = require('react');

var withClickOutside = require('./withClickOutside');

var commonPropTypes = require('../common/propTypes');

var toAsyncValidatorsArray = function toAsyncValidatorsArray(v) {
  if (_.isArray(v)) {
    return v;
  } else if (v) {
    return [v];
  }

  return [];
};

var toValidatorsArray = function toValidatorsArray(v, invalidMessage) {
  if (_.isArray(v)) {
    return _.map(v, function (validator) {
      return _.isFunction(validator) ? {
        validator: validator,
        invalidMessage: invalidMessage
      } : validator;
    });
  } else if (v) {
    return [{
      validator: v,
      invalidMessage: invalidMessage
    }];
  }

  return [];
};

var withValidation = function withValidation(Component) {
  var Validated = /*#__PURE__*/function (_React$Component) {
    _inherits(Validated, _React$Component);

    var _super = _createSuper(Validated);

    function Validated(props) {
      var _this;

      _classCallCheck(this, Validated);

      _this = _super.call(this, props);

      _this.getPropsValue = function (otherProps) {
        return _.get(otherProps || _this.props, 'valueLink.value', otherProps ? otherProps.value : _this.props.value);
      };

      _this.state = {
        isValid: null,
        valueCandidate: _this.getPropsValue(),
        successValue: _this.getPropsValue(),
        wasSuccess: false,
        tooltipIsOpen: _this.props.isValid === false,
        isSuccess: false
      };

      _this.closeTooltip = function () {
        if (_this.state.tooltipIsOpen) {
          _this.setState({
            tooltipIsOpen: false
          });
        }
      };

      _this.openTooltipIfNeeded = function () {
        var currentProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

        _this.setState({
          tooltipIsOpen: !_this.isValid(currentProps)
        });
      };

      if (props.closeTooltipOnClickOutside) {
        _this.props.onClickOutside(_this.closeTooltip);
      }

      _this.validateSync = function (value) {
        var validators = toValidatorsArray(_this.props.validator, _this.props.invalidMessage);

        if (_.isEmpty(validators)) {
          return true;
        }

        var invalid = _.find(validators, function (_ref) {
          var validator = _ref.validator;
          return !validator(value);
        });

        if (!_.isUndefined(invalid)) {
          _this.setState({
            invalidMessage: invalid.invalidMessage
          });

          return false;
        }

        return true;
      };

      _this.validateAsync = function (value, onSuccess, onFailure) {
        var asyncValidators = toAsyncValidatorsArray(_this.props.asyncValidator);

        if (_.isEmpty(asyncValidators)) {
          onSuccess();
        } else {
          var successResults = {};

          var validatorsNumber = _.size(asyncValidators);

          var successCounter = 0;
          var hasFailedValidation = false;

          _.forEach(asyncValidators, function (validator, validatorName) {
            var onValidatorSuccess = function onValidatorSuccess(result) {
              if (result) {
                successResults[validatorName] = result;
              }

              successCounter++;
              var isDone = successCounter === validatorsNumber;

              if (isDone) {
                onSuccess(successResults);
              }
            };

            var onValidatorError = function onValidatorError(errorMessage) {
              if (!hasFailedValidation) {
                hasFailedValidation = true;
                onFailure(errorMessage);
              }
            };

            validator(value, onValidatorSuccess, onValidatorError);
          });
        }
      }; // TODO: handle messages array or functions resolve


      _this.getMessage = function () {
        return _this.shouldEnforceValidationStatus() ? _this.props.invalidMessage : _this.state.invalidMessage;
      };

      _this.validate = function (value) {
        var onSuccess = _.partial(_this.onValidationSuccess, value);

        var onFailure = _.partial(_this.onValidationFailed, value);

        if (_this.validateSync(value)) {
          if (!_this.props.asyncValidator) {
            onSuccess();
            return;
          }

          _this.validateAsync(value, onSuccess, onFailure);
        } else {
          onFailure(_this.getMessage());
        }
      };

      var delay = _this.props.asyncValidator ? _this.props.asyncDelay : _this.props.syncDelay;

      if (delay) {
        _this.validate = _.debounce(_this.validate, delay);
      }

      _this.showSuccess = function () {
        if (_this.isValid() && (!_this.state.wasSuccess || _this.state.successValue !== _this.state.valueCandidate)) {
          _this.setState({
            wasSuccess: true,
            successValue: _this.state.valueCandidate
          });

          if (!_this.props.hideSuccessIndication) {
            _this.setState({
              isSuccess: true
            });

            _this.successTimer = window.setTimeout(function () {
              return _this.setState({
                isSuccess: false
              });
            }, 1000);
          }
        }
      };

      _this.onFocus = function (e) {
        if (_.isFunction(_this.props.onFocus)) {
          _this.props.onFocus(e);
        }

        if (!(_this.props.validateInitialValue && !_this.valueChanged) || _this.shouldEnforceValidationStatus()) {
          _this.openTooltipIfNeeded();
        }
      };

      _this.onBlur = function (e, isCanceled) {
        _this.closeTooltip();

        if (_this.props.validateOnBlur) {
          _this.validate(_this.state.valueCandidate);
        }

        if (_.isFunction(_this.props.onBlur)) {
          _this.props.onBlur(e, isCanceled);
        }

        if (!isCanceled) {
          _this.showSuccess();
        }
      };

      _this.onChange = function (value, isValid) {
        var _this$props$valueLink;

        var onChangeProp = ((_this$props$valueLink = _this.props.valueLink) === null || _this$props$valueLink === void 0 ? void 0 : _this$props$valueLink.requestChange) || _this.props.onChange || function () {
          return undefined;
        };

        onChangeProp(value, isValid);
      };

      _this.onValidationFailed = function (val, errorMessage) {
        _this.setState({
          isValid: false,
          wasSuccess: false,
          tooltipIsOpen: !_this.isInitialValidation || _this.isInitialValidation && _this.props.tooltipOnInitialValidation,
          invalidMessage: errorMessage || _this.props.invalidMessage
        });

        if (_this.props.allowInvalidChange) {
          _this.onChange(val, false);
        }

        if (_.isFunction(_this.props.onValidationStatus)) {
          _this.props.onValidationStatus(false);
        }

        _this.isInitialValidation = false;
      };

      _this.onValidationSuccess = function (val) {
        _this.setState({
          isValid: true,
          tooltipIsOpen: false,
          invalidMessage: null
        });

        _this.showSuccess();

        _this.onChange(val, true);

        if (_.isFunction(_this.props.onValidationStatus)) {
          _this.props.onValidationStatus(true);
        }

        _this.isInitialValidation = false;
      };

      _this.onValueStateChange = function (value) {
        _this.valueChanged = true;

        _this.setState({
          valueCandidate: value
        }, function () {
          if (_this.shouldValidate()) {
            _this.validate(value);
          } else {
            _this.onChange(value);
          }
        });
      };

      _this.shouldEnforceValidationStatus = function () {
        var currentProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        return _.isBoolean(currentProps.isValid);
      };

      _this.shouldValidate = function () {
        var currentProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        return !_this.shouldEnforceValidationStatus(currentProps) && currentProps.validator || currentProps.asyncValidator;
      };

      _this.isValid = function () {
        var currentProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
        var currentState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state;
        return _this.shouldEnforceValidationStatus(currentProps) ? currentProps.isValid : currentState.isValid;
      };

      _this.getValidationProps = function () {
        var shouldValidate = _this.shouldValidate();

        var shouldEnforceValidationStatus = _this.shouldEnforceValidationStatus();

        if (!(shouldEnforceValidationStatus || shouldValidate)) {
          return _this.props;
        }

        return _.assign({}, _this.props, {
          invalidMessage: _this.isValid() === false ? _this.getMessage() : '',
          tooltipIsOpen: _this.state.tooltipIsOpen,
          onFocus: _this.onFocus,
          onChange: _this.onValueStateChange,
          value: _this.state.valueCandidate,
          success: _this.state.isSuccess,
          successValue: _this.state.successValue,
          onBlur: _this.onBlur
        });
      };

      return _this;
    }

    _createClass(Validated, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        var isValid = this.isValid();

        if (isValid !== null && _.isFunction(this.props.onValidationStatus)) {
          this.props.onValidationStatus(isValid);
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        window.addEventListener('wheel', this.closeTooltip);
        window.addEventListener('scroll', this.closeTooltip);

        if (this.props.validateInitialValue && this.shouldValidate()) {
          this.isInitialValidation = true;
          var value = this.state.valueCandidate;
          this.validate(value);
        } else if (this.shouldEnforceValidationStatus()) {
          this.tooltipTimer = window.setTimeout(function () {
            return _this2.openTooltipIfNeeded();
          }, 0);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('wheel', this.closeTooltip);
        window.removeEventListener('scroll', this.closeTooltip);
        window.clearTimeout(this.successTimer);
        window.clearTimeout(this.tooltipTimer);

        if (this.props.cancelValidationOnUnmount && _.isFunction(this.validate.cancel)) {
          this.validate.cancel();
        }
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var nextValue = this.getPropsValue(nextProps);
        var currentValue = this.getPropsValue();

        if (nextValue !== this.state.valueCandidate && nextValue !== currentValue) {
          this.setState({
            valueCandidate: nextValue
          }, function () {
            if (_this3.shouldValidate() && _this3.props.validateOnValuePropChange) {
              _this3.validate(_this3.state.valueCandidate);
            } else if (_this3.shouldEnforceValidationStatus() && _this3.props.validateOnValuePropChange) {
              _this3.openTooltipIfNeeded(nextProps);
            }
          });
        } else if (nextProps.isValid !== this.props.isValid) {
          this.openTooltipIfNeeded(nextProps);
        }

        if (this.isValid(nextProps) !== this.isValid(this.props)) {
          if (_.isFunction(this.props.onValidationStatus)) {
            this.props.onValidationStatus(this.isValid(nextProps));
          }

          this.setState({
            wasSuccess: this.isValid(this.props, this.state)
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.getValidationProps();
        return React.createElement(Component, props);
      }
    }]);

    return Validated;
  }(React.Component);

  Validated.propTypes = commonPropTypes.VALIDATED_PROP_TYPES;
  Validated.defaultProps = {
    allowInvalidChange: false,
    validateInitialValue: true,
    validateOnBlur: false,
    tooltipOnInitialValidation: false,
    tooltipInteractive: false,
    validateOnValuePropChange: true,
    syncDelay: 50,
    asyncDelay: 300,
    cancelValidationOnUnmount: true,
    closeTooltipOnClickOutside: true,
    hideSuccessIndication: false
  };
  return withClickOutside(Validated);
};

module.exports = withValidation;